import { render, staticRenderFns } from "./SeccionesInforme.vue?vue&type=template&id=5c17b831&"
import script from "./SeccionesInforme.vue?vue&type=script&lang=js&"
export * from "./SeccionesInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports